import { render, staticRenderFns } from "./ConfirmDialog.vue?vue&type=template&id=39b8c832&scoped=true&"
import script from "./ConfirmDialog.vue?vue&type=script&lang=js&"
export * from "./ConfirmDialog.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmDialog.vue?vue&type=style&index=0&id=39b8c832&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b8c832",
  null
  
)

export default component.exports